<script>
  import ItemPage from '../components/ItemPage.vue'

  export default {
    components: { ItemPage },
  }
</script>


<template>
  <ItemPage :narrowCols="[]">
    <template #title>
      <span>Not Found.</span>
      <small>The requested URL was not found on this server.</small>
    </template>
  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  .Page ::v-deep .Page__title {
    h1 > span,
    h1 > small {
      display: block;
      margin: 0;
      padding: 0;
    }

    h1 > small {
      margin-top: 0.2em;
      font-size: $size-unit * 5;
    }
  }
</style>
